import Vue from "vue";
import VueRouter from "vue-router";
import { adminRouteGuard } from "@/utils/adminRouteGuard";
Vue.use(VueRouter);
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const routes = [
  {
    path: "/",
    redirect: "index"
  },
  // 登录login
  {
    path: "/login1",
    name: "login1",
    component: () => import("@/components/logins/view/login1.vue"),
    redirect: {
      name: "logins"
    },
    children: [
      // 登录
      {
        path: "/logins",
        name: "logins",
        component: () => import("@/components/logins/view/logins.vue")
      },
      //注册
      {
        path: "/reg",
        name: "reg",
        component: () => import("@/components/logins/view/reg.vue")
      },
      //忘记密码
      {
        path: "/forget",
        name: "forget",
        component: () => import("@/components/logins/view/forget.vue")
      }
    ]
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index.vue"),
    redirect: {
      name: "indexPage"
    },
    children: [
      // {
      //   path: '/IndexxPage2',
      //   name: 'IndexxPage2',
      //   component: () => import("@/views/Home/IndexxPage2"),
      // },
      {
        path: "/indexPage",
        name: "indexPage",
        component: () => import("@/views/Home/IndexPage.vue")
      },
      // 二大赛道
      {
        path: "/competition",
        name: "indeTwo",
        component: () => import("@/views/Home/IndexxPage2.vue"),
        props: { sidebar: false }
      },
      // 三大赛道
      {
        path: "/indexHome",
        name: "indexHome",
        component: () => import("@/views/Page/indexPage.vue"),
        props: { sidebar: false }
      },
      // 新文科模块
      {
        path: "/xinwenke",
        name: "xinwenke",
        component: () => import("@/views/Home/XinWenKePage.vue"),
        props: { sidebar: false }
      },
      // 大挑模块
      {
        path: "/bigchallenge",
        name: "bigchallenge",
        component: () => import("@/views/Home/BigChallengePage.vue"),
        props: { sidebar: false }
      },
      // 小挑模块
      {
        path: "/smallchallenge",
        name: "smallchallenge",
        component: () => import("@/views/Home/SmallChallengePage.vue"),
        props: { sidebar: false }
      },
      {
        path: "/Page",
        name: "Page",
        component: () => import("@/views/Page/Page.vue"),
        props: { sidebar: false },
        redirect: {
          name: "PPThome"
        },
        children: [
          {
            path: "/PPThome",
            name: "PPThome",
            component: () => import("@/views/Page/PPThome.vue"),
            props: { sidebar: false }
          },
          {
            path: "/Pagedetails",
            name: "Pagedetails",
            component: () => import("@/views/Page/Pagedetails.vue"),
            props: { sidebar: false }
          }
        ]
      },
      // 个人中心
      {
        path: "/Personalcenter",
        name: "Personalcenter",
        component: resolve =>
          require(["@/views/Page/Personalcenter.vue"], resolve),
        props: { sidebar: false },
        redirect: { name: "Downloadlatest" },
        children: [
          //我的下载
          {
            path: "/Downloadlatest",
            name: "Downloadlatest",
            component: resolve =>
              require(["@/views/Page/Downloadlatest.vue"], resolve),
            props: { sidebar: false }
          },
          //我的收藏
          {
            path: "/Mycollection",
            name: "Mycollection",
            component: resolve =>
              require(["@/views/Page/Mycollection.vue"], resolve),
            props: { sidebar: false }
          },
          //消息中心
          {
            path: "/Messagecenter",
            name: "Messagecenter",
            component: resolve =>
              require(["@/views/Page/Messagecenter.vue"], resolve),
            props: { sidebar: false }
          },
          //兑换码
          {
            path: "/Conversioncode",
            name: "Conversioncode",
            component: resolve =>
              require(["@/views/Page/Conversioncode.vue"], resolve),
            props: { sidebar: false }
          },
          //个人信息
          {
            path: "/Perstion",
            name: "Perstion",
            component: resolve =>
              require(["@/views/Page/Perstion.vue"], resolve),
            props: { sidebar: false }
          },
          //修改密码
          {
            path: "/Chapassword",
            name: "Chapassword",
            component: resolve =>
              require(["@/views/Page/Chapassword.vue"], resolve),
            props: { sidebar: false }
          },
          //文件管理（管理员功能）
          {
            path: "/FileManagement",
            name: "FileManagement",
            component: resolve =>
              require(["@/views/Page/FileManagement.vue"], resolve),
            props: { sidebar: false },
            meta: {
              requiresAdmin: true,
              requiredPermission: 'canFileManage'
            }
          },
          //分类管理（管理员功能）
          {
            path: "/CategoryManagement",
            name: "CategoryManagement",
            component: resolve =>
              require(["@/views/Page/CategoryManagement.vue"], resolve),
            props: { sidebar: false },
            meta: {
              requiresAdmin: true,
              requiredPermission: 'canFileManage'
            }
          },
          //电子卡管理（管理员功能）
          {
            path: "/EcardManagement",
            name: "EcardManagement",
            component: resolve =>
              require(["@/views/Page/EcardManagement.vue"], resolve),
            props: { sidebar: false },
            meta: {
              requiresAdmin: true,
              requiredPermission: 'canFileManage'
            }
          },
          //轮播图管理（管理员功能）
          {
            path: "/BannerManagement",
            name: "BannerManagement",
            component: resolve =>
              require(["@/views/Page/BannerManagement.vue"], resolve),
            props: { sidebar: false },
            meta: {
              requiresAdmin: true,
              requiredPermission: 'canFileManage'
            }
          }
        ]
      },
      // 详情页
      {
        path: "/Detailspage",
        name: "Detailspage",
        component: resolve =>
          require(["@/views/Page/Detailspage.vue"], resolve),
        props: { sidebar: true }
      },
      // zzh详情页
      {
        path: "/details",
        name: "details",
        component: resolve => require(["@/views/Home/details.vue"], resolve),
        props: { sidebar: true }
      },
      // 新文科详情页
      {
        path: "/xinwenke-detail",
        name: "XinWenKeDetail",
        component: () => import("@/views/Page/XinWenKeDetail.vue"),
        props: { sidebar: true }
      },
      // 大挑详情页
      {
        path: "/bigchallenge-detail",
        name: "BigChallengeDetail",
        component: () => import("@/views/Page/BigChallengeDetail.vue"),
        props: { sidebar: true }
      },
      // 小挑详情页
      {
        path: "/smallchallenge-detail",
        name: "SmallChallengeDetail",
        component: () => import("@/views/Page/SmallChallengeDetail.vue"),
        props: { sidebar: true }
      },
      // 搜索页
      {
        path: "/SearchPage",
        name: "SearchPage",
        component: resolve => require(["@/views/Page/SearchPage.vue"], resolve),
        props: { sidebar: true }
      },
      // 关于我们
      {
        path: "/Contactus",
        name: "Contactus",
        component: () => import("@/views/Page/Contactus.vue"),
        props: { sidebar: true }
      }
    ]
  },

  // 用户协议
  {
    path: "/Useragreement",
    name: "Useragreement",
    component: () => import("@/views/Page/Useragreement.vue"),
    props: { sidebar: true }
  },
  // 管理员登录
  {
    path: "/admin-login",
    name: "AdminLogin",
    component: () => import("@/components/admin/AdminLogin.vue"),
    props: { sidebar: false }
  },
  //支付
  {
    path: "/orderAlipay",
    name: "orderAlipay",
    component: () => import("@/views/Page/orderAlipay.vue"),
    props: { sidebar: true }
  }
  // 重定向
  // {
  //   path: "/",
  //   redirect: "/2"
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// 添加管理员路由守卫
router.beforeEach(adminRouteGuard);

export default router;
